import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JsaPage } from './jsa';

@NgModule({
  declarations: [
    JsaPage,
  ],
  imports: [
    IonicPageModule.forChild(JsaPage),
  ],
})
export class JsaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/jsa/jsa.module.ts